module.exports = __webpack_public_path__ + "Img_Nubic_512px.png";